import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SidebarEditor } from "@/components/SidebarEditor";

export default function NavigationManager() {
  const [enc, setEnc] = useState("ghoulax");
  return (
    <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6">
      <Link to="/admin" className="inline-flex items-center gap-1 text-sm hover:underline" style={{ color: "var(--arc-text-2)" }}><ArrowLeft size={14} /> Dashboard</Link>
      <h1 className="mt-4 font-serif-arc text-3xl font-black">Sidebar Navigation</h1>
      <p className="mt-2 text-sm" style={{ color: "var(--arc-text-2)" }}>Customise the browse sidebar shown on each encyclopedia's pages — or hide it entirely.</p>

      <div className="mt-6 inline-flex overflow-hidden rounded-md border" style={{ backgroundColor: "var(--arc-card)" }}>
        {["ghoulax", "zyfley"].map((e) => (
          <button
            key={e}
            onClick={() => setEnc(e)}
            data-testid={`nav-tab-${e}`}
            className="px-5 py-2 text-sm font-semibold transition-colors"
            style={enc === e ? { backgroundColor: e === "ghoulax" ? "var(--ghoulax)" : "var(--zyfley)", color: e === "ghoulax" ? "var(--ghoulax-fg)" : "#fff" } : { color: "var(--arc-text-2)" }}
          >
            {e === "ghoulax" ? "Ghoulax" : "Zyfley"}
          </button>
        ))}
      </div>

      <div className="mt-6">
        <SidebarEditor key={enc} enc={enc} />
      </div>
    </div>
  );
}
